export default i => (i == null || isNaN(i)) ? '-' : `$${Number.parseFloat(i).toFixed(2)}`;
